export default [{
  name: 'safeplan',
  path: '/safeplan/:fundNum?',
  meta: {
    layout: 'LegacyLayoutFluid'
  },
  props: true,
  component: require('@/pages/safeplan/Safeplan.vue').default
}]
